export const ADD_TO_CART_BEGIN = "ADD_TO_CART_BEGIN";
export const ADD_TO_CART_DISCARD = "ADD_TO_CART_DISCARD";
export const ADD_TO_CART_FAILURE = "ADD_TO_CART_FAILURE";
export const ADD_TO_CART_PRICE_HAS_CHANGED = "ADD_TO_CART_PRICE_HAS_CHANGED";
export const ADD_TO_ASYNC_CART_PRICE_HAS_CHANGED =
  "ADD_TO_ASYNC_CART_PRICE_HAS_CHANGED";
export const ADD_TO_CART_PRICE_HAS_CHANGED_ACCEPTED =
  "ADD_TO_CART_PRICE_HAS_CHANGED_ACCEPTED";
export const ADD_TO_CART_PRICE_HAS_CHANGED_REFUSED =
  "ADD_TO_CART_PRICE_HAS_CHANGED_REFUSED";
export const ADD_TO_CART_SUCCESS = "ADD_TO_CART_SUCCESS";
export const POLLING_COMPLETE = "POLLING_COMPLETE";
export const SORT_DEPARTURES = "SORT_DEPARTURES";
export const TRACK_SELECTED_TRIP = "TRACK_SELECTED_TRIP";
export const TRACK_VIEW_TICKET_OPTIONS = "TRACK_VIEW_TICKET_OPTIONS";
export const TRACK_VIEW_ASYNC_CART = "TRACK_VIEW_ASYNC_CART";
export const TRACK_VIEW_SEAT_SELECTION = "TRACK_VIEW_SEAT_SELECTION";
export const UPDATE_CART_CHARGES = "UPDATE_CART_CHARGES";
export const TICKET_OPTIONS_CARD_COLLAPSE = "TICKET_OPTIONS_CARD_COLLAPSE";
export const TICKET_OPTIONS_CARD_EXPAND = "TICKET_OPTIONS_CARD_EXPAND";
export const SET_BB_YIELDIFY_EVENT_DATA = "SET_BB_YIELDIFY_EVENT_DATA";
